import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";

import Table from "@client/components/ui/Table";
import Style from "@client/utils/Style";
import { LicensorWithRole } from "@typings/Licensor";
import AlertModal from "@client/components/ui/AlertModal";

const LicensorActions = styled.div``;
const LicensorAction = styled.div<{ palette?: React.CSSProperties["color"] }>`
  display: inline-block;
  color: ${props => props.palette || Style.palette.alert};
  cursor: pointer;
  margin-right: 8px;
  &:last-child {
    margin-right: 0;
  }
  &:hover {
    text-decoration: underline;
  }
`;

type Props = {
  licensors: LicensorWithRole[];
  onRemoveLicensor: (licensor: LicensorWithRole) => void;
  onDisableLicensor: (licensor: LicensorWithRole) => void;
};
type State = {
  showRemoveAlert: LicensorWithRole | null;
};
@observer
class LicensorsTable extends React.Component<Props, State> {
  state: State = {
    showRemoveAlert: null,
  };

  render() {
    const items = this.props.licensors.map(licensor => {
      return [
        licensor.id,
        licensor.name,
        licensor.email,
        licensor.description,
        licensor.role_name,
        <LicensorActions key={licensor.id}>
          <LicensorAction
            palette={
              licensor.enabled ? Style.palette.alert : Style.palette.primary
            }
            onClick={() => {
              this.props.onDisableLicensor(licensor);
            }}
          >
            {licensor.enabled ? "Disable" : "Enable"}
          </LicensorAction>
          <LicensorAction
            onClick={() => {
              this.setState({ showRemoveAlert: licensor });
            }}
          >
            Remove
          </LicensorAction>
        </LicensorActions>,
      ];
    });

    return (
      <>
        <Table
          header={["ID", "Name", "Email", "Description", "Role", "Actions"]}
          noItemsLabel="No licensors created for this partner."
          items={items}
          useSecondaryStyle
        />
        {this.state.showRemoveAlert ? (
          <AlertModal
            isOpen
            message={`Are you sure you want to remove licensor ${this.state.showRemoveAlert.name}?`}
            extraMessage="This action cannot be undone."
            onConfirmation={() => {
              this.props.onRemoveLicensor(this.state.showRemoveAlert!);
              this.setState({ showRemoveAlert: null });
            }}
            onRequestClose={() => {
              this.setState({ showRemoveAlert: null });
            }}
            title="Remove Licensor"
          />
        ) : null}
      </>
    );
  }
}

export default LicensorsTable;
